import { unminifyError } from '@sgme/stacktrace';
import type { Middleware } from 'redux';
import { unhandledError } from 'state/actions';
import type { AppState } from 'state/state.model';
import type { IFrontLogger } from 'utils/loggers/FrontLogger';

const queueSize = 20;

const actionsQueue: string[] = [];

export function getLastActions(): ReadonlyArray<string> {
  return actionsQueue.slice();
}

export const catchMiddleware: (logger: IFrontLogger) => Middleware<{}, AppState> =
  logger => store => next => async action => {
    if (action.type) {
      while (actionsQueue.length >= queueSize) {
        actionsQueue.shift();
      }
      actionsQueue.push(action.type);
    }
    try {
      return await next(action);
    } catch (error: any) {
      const err = await unminifyError(error);
      logger.error(
        'thunk or reducer crashed {@FrontError} for action {@Action} given last actions {@LastActions}',
        err,
        JSON.stringify(action),
        JSON.stringify(actionsQueue),
      );
      store.dispatch(
        unhandledError(
          'A technical error happened, please retry or contact your support',
          err,
          `in redux : action: ${JSON.stringify(action)}`,
        ),
      );
    }
  };
